import { Slide } from "@jelly/lesson";
import config from "appConfig";

const principle: Slide = {
  title: "Introduction",
  layout: {
    type: "customCase020201",
    options: {
      visualizationSrc: `${config.ASSETS_URL}/02/case02/vis.svg`,
    },
  },
};

export default principle;
